<template>
    <div class="address-box">
        <van-nav-bar title="通讯录" :fixed="true" left-text="返回" :border="false" left-arrow @click-left="backPage" />
        <div class="address-list">
            <div class="address-title">
            <p>添加到通讯录的成员才能给设备打电话，确保家人不会被陌生来电骚扰</p>
            </div>
            <div v-if="flag" class="address-content">
            <img class="address-img" src="@/assets/images/address_list.png" background-size="cover" />
            <p class="address-txt">通讯录为空</p>
            </div>
            <div v-else class="address-option">
                <div v-for="(item,index) in addressList" :key="index" class="list-content" @click="addLinkman(item,index)">
                <img class="list-img" src="@/assets/images/morentouxiangbeifen.png" background-size="cover" />
                <div class="list-center">
                    <p class="list-name">{{item.name}}</p>
                    <p class="list-sim">{{item.sim}}</p>
                </div>
                </div>
            </div>
            <div class="btn-box">
            <van-button round type="info" @click="addLinkman">添加联系人</van-button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            addressList:[],//联系人列表
            flag:false,//联系人为空时展示
        };
    },
    created() {
        this.getAddressList()
    },
    methods: {
        /**
        * 获取通讯录列表
        */
        getAddressList(){
            let data = {
                ver:1,
                method:'getInstructById',
                instructionId:this.$intfilter.instructFilter('白名单')
            }
            this.$http.get(this.$api.userInfo.POST_APPLET,data).then(res => {
                if (res.code === 0) {
                this.addressList = []
                if(!res.data.params || res.data.params===""  || res.data.params==="null"){
                    this.flag = true
                    return
                }else{
                    this.flag = false
                }
                let arr = res.data.params.split(',')
                for (let i = 0; i < arr.length/2; i++) {
                    this.addressList.push({
                    name:arr[i*2],
                    sim:arr[i*2+1],
                    // instructId: res.data.instructId
                    })
                }
                } else {
                    this.$toast({
                        message: res.msg,
                        duration: 2000,
                        icon: require('@/assets/images/safety-fence/wrong.png'),
                    });
                }
            })
        },
        /**
         * 页面跳转
         */
        addLinkman(item,index){
            item && (item.index = index)
            this.$router.push({ name: 'addMail', query: { data: JSON.stringify(item) } });
        },
        /**
         * 返回上一次路由
         */
        backPage() {
            this.$router.back(-1);
        },
    }
};
</script>

<style lang="scss" scoped>
.address-list{
  background: #f8f8f8;
  padding: 60px 40px 0;
  min-height: 100vh;
}
.address-title{
  font-size: 26px;
  font-weight: 400;
  color: #666;
  padding-top: 60px;
  margin-bottom: 60px;
}
.address-content{
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 300px;
  font-size: 28px;
  font-weight: 400;
  color: #999999;
}
.address-img{
  width: 426px;
  height: 230px;
}
.address-option{
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 180px;
}
.list-content{
  width: 686px;
  height: 160px;
  background: #fff;
  border-radius: 20px;
  display: flex;
  align-items: center;
  margin-bottom: 25px;
}
.list-img{
  width: 80px;
  height: 80px;
  margin: 0 35px;
}
.list-name{
  font-size: 36px;
  font-weight: 600;
  color: #000000;
}
.list-sim{
  font-size: 28px;
  font-weight: 400;
  color: #999999;
}
.btn-box{
  z-index: 1;
  position: fixed;
  width: 100%;
  padding: 20px 0 50px;
  bottom: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #f8f8f8;
}
</style>
<style lang="scss">
.address-list .van-button{
  margin: 0 auto;
  border: none;
  width: 586px;
  height: 98px;
  background-color: #01ADA9;
}
.address-box{
    .van-nav-bar{
        background-color: #F8F8F8;
    }
}

</style>